import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { default as i18next } from '../../../../i18n';
import { StyledLink } from '../../Reporting/ReportingForgotPassword/ReportingForgotPassword.styles';
import { Description, Heading, IconContainer } from './ResetResult.styled';

interface ResetResultProps {
  isSuccess: boolean;
  isReporting?: boolean;
}

export const ResetResult = ({ isSuccess, isReporting }: ResetResultProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const emptyStateSrc = theme.isVaultVariant
    ? '/assets/empty-state.svg'
    : '/assets/empty-state-atlas.svg';
  const emailComponentToBeEmbedded = (
    <StyledLink
      href="mailto:techsupport@vaultplatform.com"
      size="medium"
      target="_blank"
      rel="no-referrer"
    />
  );

  const heading = isSuccess
    ? t('reporting.ReportingReset.successHeading')
    : t('reporting.ReportingReset.failureHeading');
  const description = isSuccess ? (
    isReporting ? (
      t('reporting.ReportingReset.successDescription')
    ) : (
      t('reporting.ReportingForgotPassword.updatePasswordSuccessDescription')
    )
  ) : (
    <Trans
      i18n={i18next}
      i18nKey="reporting.ReportingReset.failureDescription"
      components={{
        mailto: emailComponentToBeEmbedded,
      }}
    />
  );

  return (
    <>
      <IconContainer>
        <img src={emptyStateSrc} alt="Empty state" width="100%" />
      </IconContainer>
      <Heading>{heading}</Heading>
      <Description>{description}</Description>
    </>
  );
};
